<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)"
    >
        <el-row>
            <el-col :span="2" style="height:1px;"></el-col>
            <el-col :span="20" :class="$style.wrapper" class="subjectList">
                <div :class="$style.top">
                    <div style="margin-top: -10px" align="center">
                        <listSegment ref="listSegment"  @changeRadio="changeRadio"></listSegment>
                    </div>
                </div>
                <div :class="$style.bottom">
                    <div v-show="radio === '尚未下单'">
                        <firstTable ref="firstTable"/>
                        <pagination :page="page" @changePage="changePageClick"></pagination>
                    </div>

                    <div v-show="radio === '进行中的工单'">
                        <secondTable ref="secondTable" />
                        <pagination :page="page2" @changePage="changePageClick2"></pagination>
                    </div>

                    <div v-show="radio === '所有工单'">
                        <thirdTable ref="thirdTable" @addNewAction="addNewAction"
                                    @serviceManageAction="serviceManageAction" @queryAction="queryAction"/>
                        <pagination :page="page3" @changePage="changePageClick3"></pagination>
                    </div>

                </div>
            </el-col>
            <el-col :span="2"></el-col>
        </el-row>

        <addService ref="addService" @showImageAction="showImageAction" @openLoading="openLoading" @initData="initData"></addService>
        <showImageDialog  ref="showImageDialog"></showImageDialog>

    </div>
</template>

<script>
    import http from '../../APIService/http'

    import ElInput from "../../../node_modules/element-ui/packages/input/src/input.vue";
    import ElRow from "element-ui/packages/row/src/row";

    import pagination from '../../components/pagination'

    import listSegment from './segment/listSegment.vue'

    import addService from './dialog/addService.vue'
    import showImageDialog from './dialog/showImageDialog.vue'

    import firstTable from './tableList/firstTable.vue'
    import secondTable from './tableList/secondTable.vue'
    import thirdTable from './tableList/thirdTable.vue'

    export default {
        data() {
            return {
                loading : false,

                listServiceSheet : {},

                radio: '尚未下单',
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                page2: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                page3: {
                    current: 1,
                    size: 5,
                    total: 0
                },
            }
        },
        components: {
            ElRow,
            ElInput,
            pagination,
            firstTable,
            secondTable,
            thirdTable,
            listSegment,
            addService,
            showImageDialog
        },
        computed: {},
        created() {


            this.radio = this.$store.getters.getRadio.radio
            if (this.radio == ''){
                this.radio = '尚未下单'
            }
            this.page = this.$store.getters.getPage1
            this.page2 = this.$store.getters.getPage2
            this.page3 = this.$store.getters.getPage3
            this.init()

        },
        methods: {
            openLoading(){
              this.loading = true
            },

            showImageAction(data){
                this.$refs.showImageUrl.show(data.showImageUrl)
            },
            addNewAction() {
                this.$refs.addService.showDialog()

            },
            serviceManageAction() {
                this.$router.push({
                    path: '/serviceManage',
                })

            },
            queryAction() {
                this.page3.size = 5
                this.page3.current = 1
                this.$store.commit('setPage3',this.page3)

                this.init()
            },
            changeRadio(radio){
                if (this.radio != radio){
                    this.radio = radio
                    this.init()
                }
            },
            initData() {
                this.page3.size = 5
                this.page3.current = 1
                this.$store.commit('setPage3',this.page3)
                this.init()
            },

            async init() {
                this.loading = true

                var obj = this.$store.getters.getUser
                try {
                    if (this.radio === '尚未下单') {
                        var status = ["NEW", "AWAIT"]
//                        var firstData = []

                        let data = {
                            tenant_id: obj.tenant_id,
                            user_id: obj.user_id,
                            pageSize: this.page.size,
                            pageIndex: this.page.current,
                            status : status
                        }


                        await http.post('/wapi/v1/getTicketByStore', data).then(res => {

                            if (res.success) {
                                this.page.total = parseInt(res.count)
                                this.$store.commit('setPage1',this.page)
                                this.$refs.firstTable.getData(res.data)
                            }
                            this.loading = false
                        })
                    }
                    else if (this.radio === '进行中的工单') {

                        let data = {
                            tenant_id: obj.tenant_id,
                            user_id: obj.user_id,
                            pageSize: this.page2.size,
                            pageIndex: this.page2.current,
                            status: ["REPORT_REJECTED", "LIST_UNCONFIRMED", "QUOTATION_UNCONFIRMED", "REPORT_UNCONFIRMED",
                                "REFUSED", "LIST_CONFIRMED", "SERVICE_REFUSED", "QUOTATION_CONFIRMED", "QUOTATION_REJECTED",
                                "ACCEPTED", "VACANT_ORDER", "REPORT_CONFIRMED", "LIST_REJECTED", "DISPATCHED"]
                        }


                        await http.post('/wapi/v1/getTicketByStore', data).then(res => {
                            if (res.success) {

                                this.page2.total = parseInt(res.count)
                                this.$store.commit('setPage2',this.page2)
                                this.$refs.secondTable.getData(res.data)


                            }
                            this.loading = false
                        })
                    }
                    else if (this.radio === '所有工单') {
                        this.thirdData = []

                        var thirdTable = this.$store.getters.getListServiceSheet
//                        this.form.name =  listServiceSheet.name
//                        this.form.address =  listServiceSheet.address
//                        this.form.comments =  listServiceSheet.comments
//                        this.form.startDate =  listServiceSheet.startDate
//                        this.form.endDate =  listServiceSheet.endDate
//                        this.form.statusList =  listServiceSheet.statusList


                        var statusList = []
                        if (thirdTable.statusList.length > 0) {

                            /*
                            * 未接单 NEW  DISPATCHED VACANT_ORDER REFUSED
                            * 已接单 ACCEPTED
                            * 进行中 "ACCEPTED", "LIST_UNCONFIRMED", "LIST_CONFIRMED", "LIST_REJECTED",
                            * "QUOTATION_UNCONFIRMED", "QUOTATION_CONFIRMED", "QUOTATION_REJECTED", "REPORT_UNCONFIRMED",
                            * "REPORT_UNCONFIRMED", "REPORT_CONFIRMED", "REPORT_REJECTED", "SERVICE_REFUSED", ]
                            * 已完工 COMPLETED
                            * 已评价 service_receipt.store_service_content
                            */
                            var store_service_content = "0"
                            for (var i = 0; i < thirdTable.statusList.length; i++) {
                                var str = thirdTable.statusList[i]
                                if (str === "未接单") {
                                    statusList.push("NEW")
                                    statusList.push("VACANT_ORDER")
                                    statusList.push("REFUSED")
                                    statusList.push("AWAIT")

                                }
                                else if (str === "已派单") {
                                    statusList.push("DISPATCHED")
                                }
                                else if (str === "已接单") {
                                    statusList.push("ACCEPTED")
                                }
                                else if (str === "进行中") {
                                    statusList.push("ACCEPTED")
                                    statusList.push("LIST_UNCONFIRMED")
                                    statusList.push("LIST_REJECTED")
                                    statusList.push("QUOTATION_UNCONFIRMED")
                                    statusList.push("QUOTATION_CONFIRMED")
                                    statusList.push("QUOTATION_REJECTED")
                                    statusList.push("REPORT_UNCONFIRMED")
                                    statusList.push("REPORT_UNCONFIRMED")
                                    statusList.push("REPORT_CONFIRMED")
                                    statusList.push("REPORT_REJECTED")
                                    statusList.push("SERVICE_REFUSED")

                                }
                                else if (str === "已完工") {
                                    statusList.push("COMPLETED")
                                    statusList.push("CLOSED")
                                    statusList.push("REJECT")

                                }
                                else if (str == "已评价"){
                                    store_service_content = "1"
                                }
                            }
                        }


                        let data = {
                            user_id: obj.user_id,
                            tenant_id: obj.tenant_id,
                            pageSize: this.page3.size,
                            pageIndex: this.page3.current,
                            name: thirdTable.name,
                            address: thirdTable.address,
                            comments: thirdTable.comments,
//                            alias: thirdTable.alias,
                            startDate: thirdTable.startDate,
                            endDate: thirdTable.endDate,
                            status: statusList,
                            store_service_content: store_service_content
                        }
                        await http.post('/wapi/v1/getTicketByStore', data).then(res => {

                            if (res.success) {

                                this.page3.total = parseInt(res.count)
                                this.$store.commit('setPage3',this.page3)

                                this.$refs.thirdTable.getData(res)

                            }
                            this.loading = false
                        })
                    }
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            // 改变页码信息
            changePageClick(page, size) {
                                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.$store.commit('setPage1',this.page)
                this.init()
            },
            // 改变页码信息
            changePageClick2(page, size) {
                if (page) {
                    this.page2.current = page
                }
                if (size) {
                    this.page2.size = size
                }
                this.$store.commit('setPage2',this.page2)
                this.init()
            },
            // 改变页码信息
            changePageClick3(page, size) {


                if (page) {
                    this.page3.current = page
                }
                if (size) {
                    this.page3.size = size
                }
                this.$store.commit('setPage3',this.page3)
                this.init()
            },

            handleSizeChange(page) {

            },
            handleCurrentChange(page) {

            },
            handleClose(done) {
                // this.$confirm('确认关闭？')
                //     .then(_ => {
                //         done();
                //     })
                //     .catch(_ => {});
                done();
                // this.$forceUpdate()
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../assets/css/default';

    .container {
        .wrapper {
            padding: 30px 30px;
            width: 100%;
            overflow: auto;
            background: #fff;
            .top {
                .wrap {
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: nowrap;
                }
                .font {
                    margin: 0 10px;
                    font-size: $fontSize;
                    color: #3b3b3e;
                    text-align: left;
                }
            }
            .border {
                border-bottom: 2px dashed #e7eaec;
                padding: 20px 0px;
            }
            .bottom {
                margin-top: 20px;
                .table {
                    margin-top: 30px;
                }
                .pagination {
                    margin-top: 50px;
                    text-align: center;
                }
                .heng {
                    display: flex;
                    justify-content: flex-start;
                }
            }
        }

    }
</style>

<style scoped>

    .subjectList > > > .el-form-item__label {
        font-size: 14px;
        color: #000000;
        text-align: left;
        font-weight: bold;
    }
</style>





// WEBPACK FOOTER //
// src/pages/serviceWorkOrder/index.vue